import React, { FC } from 'react'
import { Confirmation } from '../shared/Confirmation'
import { Dialog } from 'components/Dialog'
import { Heading } from 'components/Heading'
import { Text } from 'components/Text'
import { useTranslation } from 'react-i18next'
import { Flex } from 'components/Flex'
import { TrafficChart } from './TrafficChart'
import { ColumnChart } from 'components/ColumnChart'
import { Stack } from 'components/Stack'
import { useTrafficData } from 'services/traffic'
import { Spinner } from 'components/Spinner'
import sinTraficoLogo from './assets/sin-trafico-logo.svg'
import { PointCoordinates } from 'models/map'
import { useMapEditorContext } from 'context/map-editor-context'
import styles from './TrafficToolWizard.module.scss'
import { useFetchOrganization } from 'services/organization'
import { useUserContext } from 'context/user-context'

const labels = [
  '0:00',
  '1:00',
  '2:00',
  '3:00',
  '4:00',
  '5:00',
  '6:00',
  '7:00',
  '8:00',
  '9:00',
  '10:00',
  '11:00',
  '12:00',
  '13:00',
  '14:00',
  '15:00',
  '16:00',
  '17:00',
  '18:00',
  '19:00',
  '20:00',
  '21:00',
  '22:00',
  '23:00',
]

export const TrafficToolWizard: FC = () => {
  const { t } = useTranslation()
  const [{ confirmed, editor }, mapEditorDispatch] = useMapEditorContext()
  const [currentUser] = useUserContext()
  const coordinates = editor.feature?.geometry?.coordinates as PointCoordinates

  const { data, status } = useTrafficData(confirmed ? coordinates : undefined)

  const { organization } = useFetchOrganization()

  const onDialogClose = () => {
    mapEditorDispatch.cancelWizard()
  }

  const SaveRegFreemium = async () => {
    var url3 = "https://report.descifra.global/CallApi.ashx?idorg=" + String(organization?.id) + "&Key=RGVzY2lmcmEwOTIz&type=traffic&userid=" + String(currentUser?.id)
    const data = await fetch(url3)
    const resp = await data.json()

    if (resp[0].status === "200") {
      //setStep('ready')
    } else {
      alert("Error en la generación del reporte, contacta a soporte.")
    }
  }

  if (confirmed) {
    return (
      <Dialog
        isOpen
        aria-label={t('traffic_report.title')}
        onClose={onDialogClose}
        className={styles.dialog}
      >
        <Stack space="medium">
          <Heading>{t('traffic_report.title')}</Heading>

          {status === 'loading' && (
            <Flex justify="center" align="center" className={styles.spinner}>
              <Spinner />
            </Flex>
          )}

          {status === 'success' && data && (
            <Stack space="xlarge">
              <Stack space="medium">
                <div>
                  <Text>{data.streetName}</Text>
                  <Text component="span">
                    {t('traffic_report.address')}: {data.address}
                  </Text>
                </div>

                <Flex justify="between" align="center">
                  <div className={styles.box}>
                    <Text weight="strong">{t('traffic_report.total_capacity')}</Text>
                    <Text>
                      {data.totalCapacity} {t('traffic_report.vehicles')}
                    </Text>
                  </div>
                  <div className={styles.box}>
                    <Text weight="strong">{t('traffic_report.average_speed')}</Text>
                    <Text>{data.averageSpeed.toFixed(2)} kmh</Text>
                  </div>
                  <div className={styles.box}>
                    <Text weight="strong">{t('traffic_report.peak_hour')}</Text>
                    <Text>{data.peakHour}</Text>
                  </div>
                </Flex>

                <Heading size="widget">{t('traffic_report.capacity_profile')}</Heading>
                <div className={styles.chartContainer}>
                  <ColumnChart
                    truncate={false}
                    data={{
                      values: [data.capacityProfile],
                      keys: labels,
                      labels,
                      colors: [['#97b952']],
                    }}
                  />
                </div>

                <Heading size="widget">{t('traffic_report.speed_and_demand')}</Heading>
                <div className={styles.chartContainer}>
                  <TrafficChart data={{ bars: data.speed, line: data.demand, labels }} />
                </div>
              </Stack>
              <Flex align="center">
                <Text weight="strong">{t('traffic_report.powered_by')}</Text>{' '}
                <img src={sinTraficoLogo} alt="Sin Tráfico" className={styles.logo} />
              </Flex>
            </Stack>
          )}
        </Stack>
      </Dialog>
    )
  }

  if (organization?.subscription.level === "Freemium") {
    SaveRegFreemium()
    return <Dialog
      isOpen
      aria-label={t('traffic_report.title')}
      onClose={onDialogClose}
      className={styles.dialog}
    >
      <Stack space="medium">
        <Heading>{t('traffic_report.title')}</Heading>
        <img src="https://report.descifra.global/PlantillasReportes/Rtrafico.png" alt=""></img>
        <img src="https://report.descifra.global/PlantillasReportes/pwtrafico.png" alt=""></img>
      </Stack>
    </Dialog>

  } else {
    return <Confirmation onConfirm={() => mapEditorDispatch.setConfirm(true)} />
  }

}

TrafficToolWizard.displayName = 'TrafficToolWizard'
